<template>
  <!-- A note's videos, beside its text and never inside it: the note's own body
       is rendered as markup (v-html) by its page, and nothing here is put there.
       Each card is the message bubble's own (play in the page, or the state it
       is in: scanning, unavailable, removed). A click anywhere in the list stays in it,
       so watching a video never opens, closes or toggles the note around it. -->
  <div
    v-if="items.length"
    class="note-attachments"
    data-test="note-attachments"
    @click.stop
  >
    <div
      v-for="(item, index) in items"
      :key="item.file_uid || `removed-${index}`"
      class="note-attachment"
      data-test="note-attachment"
    >
      <message-attachment-preview
        :attachment="item"
        variant="bubble"
      />
      <span
        v-if="badge(item)"
        :class="['note-attachment-badge', { 'is-visible': item.patient_visible }]"
        data-test="note-attachment-visibility"
      >{{ badge(item) }}</span>
    </div>
  </div>
</template>

<script>
import MessageAttachmentPreview from "@/components/private-layouts/message/MessageAttachmentPreview.vue";
import { normalizeNoteAttachments, visibilityLabel } from "@/utils/noteAttachments";

export default {
  name: "NoteAttachmentList",
  components: { MessageAttachmentPreview },
  props: {
    // A note row from GetAllNotes or GetNoteByID; its `attachments` is read.
    note: { type: Object, default: null },
  },
  computed: {
    items() {
      return normalizeNoteAttachments(this.note);
    },
  },
  methods: {
    // Only staff are told who may play a video (keyon leaves the key off for a patient).
    badge: visibilityLabel,
  },
};
</script>

<style scoped>
.note-attachments {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin: 8px 0;
}

.note-attachment {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  max-width: 100%;
}

.note-attachment-badge {
  font-size: 11px;
  line-height: 1;
  padding: 3px 8px;
  border-radius: 10px;
  background: #e5e7eb;
  color: #374151;
}

.note-attachment-badge.is-visible {
  background: #dcfce7;
  color: #166534;
}
</style>
